// @flow
import * as React from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { selectIsFetchingOneOrder } from '@gandi/billing';
import { resetCart } from '@gandi/cart';
import { notifyDanger } from '@gandi/notifications';
import { useTranslator } from '@gandi/translate';
import { Button } from '@gandi/ui';

import { doCommitCart } from 'src/Overview/modules/actions';

import { useAppSelector } from '../../../../hooks/useAppSelector';
import { selectIsAppWorking } from '../../../../modules/app';
import { useCartSummaryContext } from '../../../context/CartSummary';

import { ButtonContent } from './ButtonContent';

import styles from './Button.scss';

type Props = {
  price: string,
};

export function GenerateProformaButton({
  price,
}: Props): React.MixedElement | null {
  const dispatch = useDispatch();
  const translator = useTranslator();

  const navigate = useNavigate();

  const { orderId, setOrderId } = useCartSummaryContext();

  const { __ } = translator;

  const isAppWorking = useAppSelector(selectIsAppWorking);
  const isFetchingOrder = useAppSelector(state =>
    // $FlowFixMe[incompatible-call]
    selectIsFetchingOneOrder(state, { orderId }),
  );

  const loading = isAppWorking || isFetchingOrder;

  const handleClick: (evt: SyntheticEvent<>) => Promise<void> = async (
    evt: SyntheticEvent<>,
  ) => {
    evt.preventDefault();

    try {
      const response = await dispatch(doCommitCart());
      dispatch(resetCart());
      setOrderId(response.data.session_id);
      navigate(`/awaiting-payment/${response.data.session_id}`);
    } catch (error) {
      const title =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : __('Cart checkout error');
      const message = error.errors
        ? error.errors.map(({ description }) => description)
        : __('An error occurred when committing your cart.');
      dispatch(
        notifyDanger({
          title,
          message,
        }),
      );
    }
  };

  return (
    <Button
      block
      className={styles.button}
      loading={loading}
      onClick={handleClick}
      type="button"
    >
      <ButtonContent addon={price}>{__('Generate a proforma')}</ButtonContent>
    </Button>
  );
}
